module.exports = __webpack_public_path__ + "static/img/xiazailuyin2.d6499d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/xiazailuyin2.png
// module id = TX9/
// module chunks = 24